import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import TopBackButton from '@/component/common/top-back-button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { termDetail } from '@/api/server/terms/read';
import DangerouslySetInnerHTML from '@/lib/DangerouslySetInnerHTML';
import { authLocalStorage } from '@/lib/storage';

type termDetailProps = {
  path: string;
  type: string;
};
export default function TermDetail({ path, type }: termDetailProps) {
  const navigate = useNavigate();
  const [term, setTerm] = useState('');
  const auth = authLocalStorage().auth;
  useEffect(() => {
    (async () => {
      const re = await termDetail({ terms_id: path });
      setTerm(re);
    })();
    return () => {};
  }, [path, type]);

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          minHeight: '812px',
          height: '100vh',
          position: 'relative',
        }}
      >
        <TopBackButton
          title="이용약관"
          boxProps={{
            mb: 4,
          }}
        />
        {auth ? (
          <Button
            variant="outlined"
            size="large"
            fullWidth
            onClick={() => {
              navigate(`/terms/${type}`);
            }}
          >
            이전 내용 보러 가기
          </Button>
        ) : (
          ''
        )}
        <DangerouslySetInnerHTML
          html={{
            __html: term,
          }}
        />

        {/* <Typography
          variant="body2"
          sx={{
            color: '#2D3036',
          }}
          mb={1.5}
        >
          <DangerouslySetInnerHTML
            html={{
              __html: term,
            }}
          />
        </Typography> */}
      </Container>
    </>
  );
}
